<template>
    <div class="container">
        <md-dialog :md-active.sync="showDialogEdit" :md-click-outside-to-close="false" class="company-dialog">
            <md-dialog-title class="dialog-header">
                <span class="header-title">{{ labels.editCompany }}</span>
            </md-dialog-title>

            <md-dialog-content class="dialog-content">
                <div class="form-container">
                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.name }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.name }">
                                    <md-input
                                        type="text"
                                        name="name"
                                        v-model="Item.nombre"
                                        :placeholder="labels.name"
                                        @blur="validateField('name')"
                                    />
                                    <span class="error-message" v-if="errors.name">{{ errors.name }}</span>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.moneda }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.id_moneda }">
                                    <md-select 
                                        name="currency" 
                                        v-model="Item.id_moneda" 
                                        placeholder="Seleccione..."
                                        @blur="validateField('id_moneda')"
                                    >
                                        <md-option :key="currency.id" :value="currency.id" v-for="currency in listCurrency">
                                            {{ currency.nombre }}
                                        </md-option>
                                    </md-select>
                                    <span class="error-message" v-if="errors.id_moneda">{{ errors.id_moneda }}</span>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.acronym }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.acronym }">
                                    <md-input
                                        type="text"
                                        name="acronym"
                                        v-model="Item.acronym"
                                        :placeholder="labels.acronym"
                                        @blur="validateField('acronym')"
                                    />
                                    <span class="error-message" v-if="errors.acronym">{{ errors.acronym }}</span>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.code }}</label>
                                <md-field class="custom-field">
                                    <md-input
                                        type="text"
                                        name="code"
                                        v-model="Item.codigo"
                                        :placeholder="labels.code"
                                    />
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.nit }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.identificacion }">
                                    <md-input
                                        type="text"
                                        name="nit"
                                        v-model="Item.identificacion"
                                        :placeholder="labels.nit"
                                        @blur="validateField('identificacion')"
                                    />
                                    <span class="error-message" v-if="errors.identificacion">{{ errors.identificacion }}</span>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>

                    <b-row>
                        <b-col md="12">
                            <div class="form-group-custom">
                                <label class="label-custom">{{ labels.group }} <span class="required">*</span></label>
                                <md-field class="custom-field" :class="{ 'md-invalid': errors.id_grupos }">
                                    <md-select 
                                        name="grupo" 
                                        v-model="selectedGrupos" 
                                        placeholder="Seleccione un grupo..."
                                        multiple
                                        @blur="validateField('id_grupos')"
                                    >
                                        <md-option :value="grupo.id" v-for="grupo in listGrupos" :key="grupo.id">
                                            {{ grupo.nombre }}
                                        </md-option>
                                    </md-select>
                                    <span class="error-message" v-if="errors.id_grupos">{{ errors.id_grupos }}</span>
                                    <small class="help-text">{{ labels.multipleGroupsHelp }}</small>
                                </md-field>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </md-dialog-content>

            <md-dialog-actions class="dialog-actions">
                <div class="actions-left">
                    <md-button class="md-raised delete-btn" @click="confirmDelete">
                        <b-icon icon="trash" class="me-2"></b-icon>
                        {{ labels.delete }}
                    </md-button>
                </div>
                <div class="actions-right">
                    <md-button class="md-raised cancel-btn" @click="clicked">
                        {{ labels.close }}
                    </md-button>
                    <md-button class="md-raised md-primary save-btn" @click="editCompany">
                        {{ labels.save }}
                    </md-button>
                </div>
            </md-dialog-actions>
        </md-dialog>
    </div>
</template>

<script>
    import Company from "@/services/Company"
    import Currency from "@/services/Currency"
    import Grupo from "@/services/Grupo"

    export default {
        name: "Edit",
        props: ['showDialogEdit', 'Item'],

        data: () => ({
            listCurrency: [],
            listGrupos: [],
            selectedGrupos: [],
            errors: {
                name: "",
                id_moneda: "",
                acronym: "",
                identificacion: "",
                id_grupos: ""
            }
        }),

        watch: {
            showDialogEdit(val) {
                if (val && this.Item) {
                    this.loadGruposAndInit();
                    this.resetErrors();
                }
            },
            Item: {
                handler(newVal) {
                    if (newVal && this.showDialogEdit) {
                        this.initSelectedGrupos();
                        this.resetErrors();
                    }
                },
                deep: true
            }
        },

        computed: {
            labels() {
                if (this.$store.state._language == "es-ES") {
                    return {
                        editCompany: "Editar Compañía",
                        name: "Nombre",
                        moneda: "Moneda",
                        acronym: "Acrónimo",
                        code: "Código",
                        nit: "NIT",
                        group: "Grupo",
                        multipleGroupsHelp: "",
                        delete: "Eliminar",
                        save: "Guardar",
                        close: "Cerrar"
                    }
                } else {
                    return {
                        editCompany: "Edit Company",
                        name: "Name",
                        moneda: "Currency",
                        acronym: "Acronym",
                        code: "Code",
                        nit: "Tax ID",
                        group: "Group",
                        multipleGroupsHelp: "You can select multiple groups by holding down the Ctrl key",
                        delete: "Delete",
                        save: "Save",
                        close: "Close"
                    }
                }
            }
        },

        methods: {
            resetErrors() {
                this.errors = {
                    name: "",
                    id_moneda: "",
                    acronym: "",
                    identificacion: "",
                    id_grupos: ""
                };
            },

            validateField(field) {
                const lang = this.$store.state._language;
                
                switch(field) {
                    case 'name':
                        if (!this.Item.nombre) {
                            this.errors.name = lang == "es-ES" ? "El nombre es obligatorio" : "Name is required";
                        } else if (this.Item.nombre.length < 3) {
                            this.errors.name = lang == "es-ES" ? "El nombre debe tener al menos 3 caracteres" : "Name must have at least 3 characters";
                        } else {
                            this.errors.name = "";
                        }
                        break;
                    
                    case 'id_moneda':
                        if (!this.Item.id_moneda) {
                            this.errors.id_moneda = lang == "es-ES" ? "Debe seleccionar una moneda" : "Please select a currency";
                        } else {
                            this.errors.id_moneda = "";
                        }
                        break;
                    
                    case 'acronym':
                        if (!this.Item.acronym) {
                            this.errors.acronym = lang == "es-ES" ? "El acrónimo es obligatorio" : "Acronym is required";
                        } else if (this.Item.acronym.length < 2) {
                            this.errors.acronym = lang == "es-ES" ? "El acrónimo debe tener al menos 2 caracteres" : "Acronym must have at least 2 characters";
                        } else {
                            this.errors.acronym = "";
                        }
                        break;
                    
                    case 'identificacion':
                        if (!this.Item.identificacion) {
                            this.errors.identificacion = lang == "es-ES" ? "El NIT es obligatorio" : "Tax ID is required";
                        } else if (!/^\d{1,20}$/.test(this.Item.identificacion)) {
                            this.errors.identificacion = lang == "es-ES" ? "El NIT solo debe contener números" : "Tax ID must contain only numbers";
                        } else {
                            this.errors.identificacion = "";
                        }
                        break;
                    
                    case 'id_grupos':
                        if (!this.selectedGrupos || this.selectedGrupos.length === 0) {
                            this.errors.id_grupos = lang == "es-ES" ? "Debe seleccionar al menos un grupo" : "Please select at least one group";
                        } else {
                            this.errors.id_grupos = "";
                        }
                        break;
                }
            },

            validateForm() {
                this.validateField('name');
                this.validateField('id_moneda');
                this.validateField('acronym');
                this.validateField('identificacion');
                this.validateField('id_grupos');
                
                return !this.errors.name && 
                       !this.errors.id_moneda && 
                       !this.errors.acronym && 
                       !this.errors.identificacion && 
                       !this.errors.id_grupos;
            },

            initSelectedGrupos() {
                if (this.Item.id_grupos) {
                    this.selectedGrupos = this.Item.id_grupos
                        .split(',')
                        .map(id => parseInt(id.trim()))
                        .filter(id => !isNaN(id));
                } else {
                    this.selectedGrupos = [];
                }
            },

            async loadGruposAndInit() {
                if (this.listGrupos.length === 0) {
                    try {
                        const res = await Grupo.getAllGrupos();
                        this.listGrupos = res.data.grupos;
                        this.initSelectedGrupos();
                    } catch (error) {
                        console.error("Error loading grupos:", error);
                    }
                } else {
                    this.initSelectedGrupos();
                }
            },

            confirmDelete() {
                const message = this.$store.state._language == "es-ES"
                    ? "¿Está seguro de que desea inactivar esta compañía?"
                    : "Are you sure you want to deactivate this company?";
                
                if (window.confirm(message)) {
                    this.deleteCompany();
                }
            },

            deleteCompany() {
                Company.deleteCompany(this.Item.id)
                    .then((res) => {
                        this.$toast.success(res.data.message || (this.$store.state._language == "es-ES" 
                            ? "Compañía inactivada exitosamente" 
                            : "Company deactivated successfully"));
                        this.$emit('companyUpdated', true);
                        this.clicked();
                    })
                    .catch((error) => {
                        console.error("Error deleting company:", error);
                        let errorMessage = this.$store.state._language == "es-ES" 
                            ? "Error al inactivar la compañía" 
                            : "Error deactivating company";
                        
                        if (error.response && error.response.data) {
                            if (error.response.data.message) {
                                errorMessage = error.response.data.message;
                            } else if (error.response.data.error) {
                                errorMessage = error.response.data.error;
                            }
                        }
                        
                        this.$toast.error(errorMessage);
                    });
            },

            editCompany() {
                if (!this.validateForm()) {
                    this.$toast.error(this.$store.state._language == "es-ES" 
                        ? "Por favor, corrija los errores del formulario" 
                        : "Please correct the form errors");
                    return;
                }

                this.Item.id_grupos = this.selectedGrupos.join(',');
                
                Company.updateCompany(this.Item)
                .then((res) => {
                    this.$toast.success(res.data.message || (this.$store.state._language == "es-ES" 
                        ? "Compañía actualizada exitosamente" 
                        : "Company updated successfully"));
                    this.$emit('companyUpdated', true);
                    this.clicked();
                }).catch((error) => {
                    console.error("Error updating company:", error);
                    let errorMessage = this.$store.state._language == "es-ES" 
                        ? "Error al actualizar la compañía" 
                        : "Error updating company";
                    
                    if (error.response && error.response.data) {
                        if (error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.response.data.error) {
                            errorMessage = error.response.data.error;
                        }
                    }
                    
                    this.$toast.error(errorMessage);
                })
            },

            clicked() {
                this.$emit('clicked', false);
            }
        },
        
        mounted() {
            Currency.getAllCurrency()
            .then((res) => {
                this.listCurrency = res.data.currency;
            }).catch((error) => {
                console.error("Error loading currencies:", error);
            });
            
            this.loadGruposAndInit();
        }
    }
</script>

<style scoped>
.company-dialog >>> .md-dialog {
    max-width: 600px;
    width: 90%;
    border-radius: 8px;
    overflow: hidden;
}

.dialog-header {
    background: #34495e;
    color: white;
    padding: 20px 24px;
    margin: 0;
    border-bottom: 1px solid #2c3e50;
}

.header-title {
    font-size: 1.3rem;
    font-weight: 500;
}

.dialog-content {
    padding: 20px 24px;
    max-height: 70vh;
    overflow-y: auto;
}

.form-container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.form-group-custom {
    margin-bottom: 0;
}

.label-custom {
    display: block;
    font-weight: 600;
    color: #2c3e50;
    margin-bottom: 8px;
    font-size: 14px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.required {
    color: #e74c3c;
}

.custom-field {
    margin: 0;
}

.md-field.md-invalid .md-input,
.md-field.md-invalid .md-select {
    border-color: #ff5252;
}

.error-message {
    color: #ff5252;
    font-size: 12px;
    margin-top: 4px;
    display: block;
}

.help-text {
    color: #7f8c8d;
    font-size: 11px;
    margin-top: 4px;
    display: block;
}

.dialog-actions {
    padding: 20px 24px;
    border-top: 1px solid #ecf0f1;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: #f8f9fa;
}

.actions-left {
    display: flex;
}

.actions-right {
    display: flex;
    gap: 12px;
}

.delete-btn {
    background: #e74c3c !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 20px;
    min-width: 120px;
}

.cancel-btn {
    background: #95a5a6 !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.save-btn {
    background: #3498db !important;
    color: white !important;
    font-size: 14px;
    padding: 10px 24px;
    min-width: 100px;
}

.delete-btn:hover {
    background: #c0392b !important;
}

.cancel-btn:hover {
    background: #7f8c8d !important;
}

.save-btn:hover {
    background: #2980b9 !important;
}

/* Scroll personalizado */
.dialog-content::-webkit-scrollbar {
    width: 8px;
}

.dialog-content::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
}

.dialog-content::-webkit-scrollbar-thumb:hover {
    background: #555;
}

/* Estilos para el select múltiple de Material Design */
.custom-field >>> .md-select {
    width: 100%;
}

.custom-field >>> .md-select .md-select-value {
    min-height: 50px;
    padding: 8px;
    border: 1px solid #e0e0e0;
    border-radius: 4px;
}

/* Responsive */
@media (max-width: 768px) {
    .company-dialog >>> .md-dialog {
        width: 95%;
        margin: 16px;
    }
    
    .dialog-actions {
        flex-direction: column;
        gap: 12px;
    }
    
    .actions-left,
    .actions-right {
        width: 100%;
        justify-content: center;
    }
    
    .delete-btn, .cancel-btn, .save-btn {
        width: 100%;
        margin: 4px 0;
    }
}
</style>
